import React from 'react'
import './css/offers.css'
import exclusive_img from './assets/exclusive_image.png'
import { useNavigate } from 'react-router-dom'

const Offers = () => {

    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/men');
    }

    return (
        <div className='offers'>
            <div className="offers-left">
                <h1>Exclusive</h1>
                <h1>Offers For You</h1>
                <span>ONLY ON BEST SELLERS PRODUCTS</span>
                <button onClick={handleClick}>Check Now</button>
            </div>
            <div className="offers-right">
                <img src={exclusive_img} alt="" />
            </div>
        </div>
    )
}

export default Offers